import ReactGA from 'react-ga4';

class GoogleAnalyticsTracker {
  constructor() {
    this.tracking_id = process.env.REACT_APP_CHATBOT_TRACKING_ID;
    this.initializeTracker(this.tracking_id);
  }

  initializeTracker = (measurementId) => {
    ReactGA.initialize(`${measurementId}`);
  };

  setField = (pageName) => {
    ReactGA.set({ page_title: `${pageName}` });
  };

  sendPageView = (pagePath) => {
    ReactGA.send({ hitType: 'pageview', page: `${pagePath}` });
  };

  sendEvent = (eventObject) => {
    ReactGA.event({
      category: `${eventObject.category}`,
      action: `${eventObject.action}`,
      label: `${eventObject.label}`,
    });
  };
}

const tracker = new GoogleAnalyticsTracker();
Object.freeze(tracker);
export default tracker;
